import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetVacanciesQuery } from "../../hooks/useGetVacanciesQuery";
import { setVacancyData } from "../../redux/slices/school/vacancy";
import { routes } from "../../routes";
import { updateVacancy } from "../../services/school/vacancy/vacancy";
import { VacancyType } from "../../types/Vacancy";
import { Key_vacancies } from "../../utils/constants";

const columnNamesMap: { [key: string]: string } = {
    course: 'Curso',
    academicYear: 'Ano lectivo',
    numberOfVacancies: 'Vagas',
    occupiedVacancies: 'Ocupadas',
    availableVacancies: 'Disponíveis',
    regime: 'Regime',
};
export const Vacancies = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetVacanciesQuery({ PageNumber: currentPage, PageSize: 400 });
    const [deleteItem, setDeleteItem] = useState<VacancyType | null>(null);
    const mutationUpdate = useMutation(updateVacancy, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_vacancies);
            toast.success('Vaga apagada');
        },
        onError: () => {
            toast.error("Erro ao apagar vaga.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createVacancy)
    }
    const handleEdit = (vacancy: VacancyType) => {
        dispatch(setVacancyData(vacancy));
        navigate(routes.updateVacancy)
    };
    const handleDelete = (vacancy: VacancyType) => {
        vacancy.status = false;
        mutationUpdate.mutateAsync(vacancy)
    };
    const openDeleteDialog = (s: VacancyType) => {
        setDeleteItem(s);
    };
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
    };

    const options = data?.items.map((vacancy: VacancyType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(vacancy),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(vacancy),
            icon: <TrashIcon />
        }
    ]) || [];

    const regimeMap: Record<string, string> = {
        '1': 'Laboral',
        '2': 'Pós Laboral',
        '3': 'Distância',
    };
    
    const mappedItems = data?.items.map((vacancy: VacancyType) => ({
        ...vacancy,
        regime: vacancy.regime ? regimeMap[vacancy.regime] || "Desconhecido" : "Desconhecido",
        availableVacancies: (vacancy.numberOfVacancies ?? 0) - (vacancy.occupiedVacancies ?? 0)
    }));
    
    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={mappedItems || data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}
